import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import CoreSnackbar from '@material-ui/core/Snackbar';
import CoreSnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import style from 'providers/style';

const styles = style((theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

/**
 * @description Snackbar
 * @see https://material-ui.com/api/snackbar/
 */

// const MySnackbarContentWrapper = styles1(MySnackbarContent);

function Snackbar(props) {
  const {
    classes,
    className,
    message,
    onClose,
    variant,
    open,
    autoHideDuration,
  } = props;
  const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
  const Icon = variantIcon[variant];
  return (
    <CoreSnackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <CoreSnackbarContent
        className={[classes[variant], className].join(' ')}
        aria-describedby="client-snackbar"
        message={() => (
          <span className={classes.message}>
            <Icon className={[classes.icon, classes.iconVariant].join(' ')} />
            {message}
          </span>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </CoreSnackbar>
  );
}

export default styles(Snackbar);
